import { render, staticRenderFns } from "./addQuestionTitle.vue?vue&type=template&id=936ba4bc"
import script from "./addQuestionTitle.vue?vue&type=script&lang=js"
export * from "./addQuestionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports